module.exports = __webpack_public_path__ + "img/800.4723f5d7.png";